const OTHER_FIELDS = ['address', 'postal_code', 'phone', 'notes'];

const NAME_MATCH = 0;
const OTHER_FIELD_MATCH = 1;
const LOOSE_NAME_MATCH = 2;

function cleanText(value) {
    return String(value ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
}

function hasLettersInOrder(word, text) {
    let found = 0;
    for (const letter of text) {
        if (letter === word[found]) {
            found++;
        }
        if (found === word.length) {
            return true;
        }
    }

    return false;
}

function findMatchType(word, name, otherValues) {
    if (name.includes(word)) {
        return NAME_MATCH;
    }
    if (otherValues.some(value => value.includes(word))) {
        return OTHER_FIELD_MATCH;
    }
    if (word.length >= 3 && hasLettersInOrder(word, name)) {
        return LOOSE_NAME_MATCH;
    }

    return null;
}

function getContactScore(contact, words) {
    const name = cleanText(contact.name);
    const otherValues = OTHER_FIELDS.map(field => cleanText(contact[field])).filter(Boolean);

    let score = NAME_MATCH;
    for (const word of words) {
        const matchType = findMatchType(word, name, otherValues);
        if (matchType === null) {
            return null;
        }
        score = Math.max(score, matchType);
    }

    return score;
}

export function sortContactsByName(contacts) {
    return [...contacts].sort((a, b) => a.name.localeCompare(b.name));
}

export function searchContacts(contacts, searchText) {
    const words = searchText.split(/\s+/).map(cleanText).filter(Boolean);

    if (!words.length) {
        return sortContactsByName(contacts);
    }

    const matches = [];
    for (const contact of contacts) {
        const score = getContactScore(contact, words);
        if (score !== null) {
            matches.push({ contact, score });
        }
    }
    matches.sort((a, b) => a.score - b.score || a.contact.name.localeCompare(b.contact.name));
    return matches.map(match => match.contact);
}

export function isDarkColor(hex) {
    const match = /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex ?? '');

    if (!match) {
        return false;
    }

    const red = parseInt(match[1], 16);
    const green = parseInt(match[2], 16);
    const blue = parseInt(match[3], 16);
    const brightness = (0.299 * red + 0.587 * green + 0.114 * blue) / 255;

    return brightness < 0.6;
}
